import Skeleton from "src/common/Skeleton";
import { SCREENER_TABLE_COLUMNS } from "src/constants/screenerTableColumn";

const SKELETON_ROW_COUNT = 12;

const getSkeletonBarWidth = (key: string) => {
  switch (key) {
    case "pe_ratio":
    case "dividend_yield":
      return "w-10";
    case "volume":
      return "w-14";
    case "sector":
      return "w-24";
    case "industry":
      return "w-32";
    default:
      return "w-16";
  }
};

const ScreenerTableSkeleton = () => {
  return (
    <>
      {[...Array(SKELETON_ROW_COUNT)].map((_, index) => (
        <tr
          key={index}
          className="border-b border-gray-100 dark:border-gray-800/50"
        >
          {SCREENER_TABLE_COLUMNS.map((col) => (
            <td
              key={col.key}
              className={`px-2 pr-5 py-1.5 ${
                col.align === "right" ? "text-right" : ""
              }`}
            >
              {col.key === "symbol" ? (
                <div className="flex items-center gap-2">
                  <Skeleton className="w-5 h-5 rounded shrink-0" />
                  <div className="flex flex-col gap-1">
                    <Skeleton className="w-16 h-3.5 rounded" />
                    <Skeleton className="w-28 h-2.5 rounded" />
                  </div>
                </div>
              ) : col.align === "right" ? (
                <Skeleton
                  className={`h-3.5 rounded ml-auto ${getSkeletonBarWidth(col.key)}`}
                />
              ) : (
                <Skeleton
                  className={`h-3.5 rounded ${getSkeletonBarWidth(col.key)}`}
                />
              )}
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default ScreenerTableSkeleton;
